import { Column } from '@/components/common/DynamicTable';
import { Customer } from './types';
import { maskEmail, maskPhone } from './customerHelper';
import Avatar from '@/components/common/Avatar';
import { LOYALTY_TIER_CONFIG, getLoyaltyTierStyle } from './loyalty';

export const SIGNUP_METHOD_CONFIG: Record<string, { label: string; icon: string; bgColor: string; textColor: string }> = {
    email: { label: 'Manual – Email', icon: 'ri-mail-line', bgColor: 'bg-blue-100', textColor: 'text-blue-800' },
    phone: { label: 'Manual – Phone', icon: 'ri-phone-line', bgColor: 'bg-green-100', textColor: 'text-green-800' },
    google: { label: 'Google OAuth', icon: 'ri-google-fill', bgColor: 'bg-red-100', textColor: 'text-red-800' },
    apple: { label: 'Apple OAuth', icon: 'ri-apple-fill', bgColor: 'bg-gray-900', textColor: 'text-white' },
    app: { label: 'App', icon: 'ri-smartphone-line', bgColor: 'bg-purple-100', textColor: 'text-purple-800' },
    web: { label: 'Web', icon: 'ri-global-line', bgColor: 'bg-teal-100', textColor: 'text-teal-800' },
    // Mapping for API response values
    GOOGLE_OAUTH: { label: 'Google OAuth', icon: 'ri-google-fill', bgColor: 'bg-red-100', textColor: 'text-red-800' },
    APPLE_OAUTH: { label: 'Apple OAuth', icon: 'ri-apple-fill', bgColor: 'bg-gray-900', textColor: 'text-white' },
    MANUAL_EMAIL: { label: 'Manual – Email', icon: 'ri-mail-line', bgColor: 'bg-blue-100', textColor: 'text-blue-800' },
    MANUAL_PHONE: { label: 'Manual – Phone', icon: 'ri-phone-line', bgColor: 'bg-green-100', textColor: 'text-green-800' },
};



export const CUSTOMER_STATUS_CONFIG: Record<string, string> = {
    active: 'bg-green-100 text-green-800',
    inactive: 'bg-red-100 text-red-800',
    ...Object.fromEntries(Object.entries(LOYALTY_TIER_CONFIG).map(([k, v]) => [k, `${v.bgColor} ${v.textColor}`])),
};

// TABLE COLUMN CONFIGURATION
export const CUSTOMER_TABLE_COLUMNS: Column<Customer>[] = [
    {
        key: 'id',
        label: 'Customer ID',
        render: (row) => (
            <div className="text-sm font-medium text-gray-900">{row.id}</div>
        )
    },
    {
        key: 'name',
        label: 'Customer Name',
        render: (row) => {
            return (
                <div className="flex items-center">
                    <Avatar
                        name={row.name || 'Unknown User'}
                        imageUrl={(row as any).profileImage || (row as any).image}
                        size="md"
                        bgColor="bg-teal-100"
                        textColor="text-teal-600"
                    />
                    <div className="ml-4">
                        <div className="text-sm font-medium text-gray-900">{row.name}</div>
                        <div className="text-sm text-gray-500"> {row.email ? maskEmail(row.email) : (row.phone ? maskPhone(row.phone) : '')}</div>
                    </div>
                </div>
            );
        }
    },
    {
        key: 'signupMethod',
        label: 'Signed Up Via',
        render: (row) => {
            const config = SIGNUP_METHOD_CONFIG[row.signupMethod || ''] || { label: row.signupMethod, icon: '', bgColor: 'bg-gray-100', textColor: 'text-gray-800' };

            return (
                <span className={`inline-flex items-center px-3 py-1.5 text-xs font-semibold rounded-full ${config.bgColor} ${config.textColor}`}>
                    {config.icon && <i className={`${config.icon} mr-2`}></i>}
                    <span>{config.label}</span>
                </span>
            );
        },
    },
    {
        key: 'loyaltyTier',
        label: 'Loyalty Tier',
        render: (row) => {
            if (!row.loyaltyTier || row.loyaltyTier === '') return null;
            const config = getLoyaltyTierStyle(row.loyaltyTier);
            return (
                <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${config.bgColor} ${config.textColor}`}>
                    {row.loyaltyTier.toUpperCase()}
                </span>
            );
        },
    },
    {
        key: 'status',
        label: 'Status',
        render: (row) => (
            <span
                className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${CUSTOMER_STATUS_CONFIG[row.status] || 'bg-gray-100 text-gray-800'}`}
            >
                {row.status}
            </span>
        ),
    },
];
